import FeedbackCollector from '@atlaskit/feedback-collector';
import React from 'react';
export const FeedbackCollectorDialog = _ref => {
  let {
    userId,
    name,
    feedbackGatewayBaseUrl,
    entrypointId,
    feedbackDialogVisible,
    onSubmit,
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, feedbackDialogVisible && /*#__PURE__*/React.createElement(FeedbackCollector, {
    customGatewayUrl: "".concat(feedbackGatewayBaseUrl),
    onClose: onClose,
    onSubmit: onSubmit,
    atlassianAccountId: userId,
    name: name,
    entrypointId: entrypointId,
    submitButtonLabel: "Give Feedback",
    feedbackTitle: "Share your thoughts",
    feedbackGroupLabels: {
      bug: {
        selectOptionLabel: 'Report incorrect information',
        fieldLabel: 'Describe the issue'
      },
      comment: {
        selectOptionLabel: 'Leave a comment',
        fieldLabel: 'Describe your experience'
      },
      suggestion: {
        selectOptionLabel: 'Suggest an improvement',
        fieldLabel: 'What would you like to improve?'
      },
      question: {
        selectOptionLabel: 'Ask a question',
        fieldLabel: 'What would you like to know?'
      },
      empty: {
        selectOptionLabel: "I'd like to...",
        fieldLabel: ''
      }
    }
  }));
};